import { EventContext, Fields } from '@vimeo/bigpicture-client';

export const actionBpContextName = 'action_context';
export const actionBpContextSchemaVersion = 12;
export type ActionBpContext = Fields<
  typeof actionBpContextName,
  typeof actionBpContextSchemaVersion
>;

export const buildActionBpContext = (fields: ActionBpContext) => {
  return {
    action_context: new EventContext(actionBpContextName, actionBpContextSchemaVersion, fields),
  };
};
